<template>
  <button 
    class="button is-light is-small theme-toggle" 
    @click="toggleTheme"
    :title="currentTheme === 'dark' ? 'Switch to Light Mode' : 'Switch to Dark Mode'"
  >
    <span class="icon">
      <i :class="currentTheme === 'dark' ? 'ri-sun-line' : 'ri-moon-line'"></i>
    </span>
  </button>
</template>

<script>
export default {
  name: 'ThemeToggle',
  data() {
    return {
      currentTheme: 'light'
    }
  },
  created() {
    // Recuperar tema guardado o usar el predeterminado
    const savedTheme = localStorage.getItem('theme') || 'light'
    this.setTheme(savedTheme)
  },
  methods: {
    toggleTheme() {
      const newTheme = this.currentTheme === 'light' ? 'dark' : 'light'
      this.setTheme(newTheme)
    },
    setTheme(theme) {
      this.currentTheme = theme
      document.documentElement.setAttribute('data-theme', theme)
      localStorage.setItem('theme', theme)
      // Disparar evento storage para que otros componentes se enteren del cambio
      window.dispatchEvent(new StorageEvent('storage', {
        key: 'theme',
        newValue: theme
      }))
    }
  }
}
</script>

<style scoped>
.theme-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
}

.theme-toggle .icon {
  margin: 0;
  font-size: 1rem;
}
</style>
